module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admincentro-escolar-informacion-crear/admincentro-escolar-informacion-crear.component.scss
// module id = ./src/app/admincentro-escolar-informacion-crear/admincentro-escolar-informacion-crear.component.scss
// module chunks = main